import { combineReducers } from '@reduxjs/toolkit';

import brandsSlice from 'entities/Brand/model/brandsSlice';
import linksSlice from 'entities/Link/model/linksSlice';
import notificationsSlice from 'entities/Notification/model/notificationsSlice';
import postbackSlice from 'entities/Postback/model/postbackSlice';
import reportsSlice from 'entities/Report/model/reportsSlice';
import sourceSlice from 'entities/Source/model/sourceSlice';
import connectSourceSlice from 'features/ConnectSource/model/connectSourceSlice';
import onboardingSlice from 'features/Onboarding/model/onboardingSlice';
import shortLinkSlice from 'features/ShortLink/model/shortLinkSlice';
import { commonApi } from 'shared/api/commonApi';
import commonSlice from 'shared/model/commonSlice';
import alertsSlice from 'widgets/Alerts/model/alertsSlice';
import sidebarReducer from 'widgets/Sidebar/model/sidebarSlice';

export const rootReducer = combineReducers({
	sidebarReducer,
	commonSlice,
	alertsSlice,
	onboardingSlice,
	notificationsSlice,
	sourceSlice,
	brandsSlice,
	reportsSlice,
	shortLinkSlice,
	postbackSlice,
	linksSlice,
	connectSourceSlice,
	[commonApi.reducerPath]: commonApi.reducer,
});
